// extracted by mini-css-extract-plugin
export default {"PageTitle":"styles_PageTitle__29CMK","about":"styles_about__exEk9","container":"styles_container__Z+bFR","accent":"styles_accent__KhE8w"};